export const whipDefaults = Object.freeze({
  whipBearerToken: "", whipVideoMode: "passthrough", whipVideoCodec: "h264",
  whipVideoBitrateKbps: 0, whipVideoMaxBitrateKbps: 0, whipVideoKeyframeInterval: 0,
  whipRateControl: "", whipPreferHardwareEncoder: true, whipKlvMode: "rawAndJson",
  whipKlvPids: [], whipRequireKlv: false, whipSignalingTimeoutMs: 0,
});
export function normalizeWhip(value = {}) {
  return Object.fromEntries(Object.entries(whipDefaults).map(([key, fallback]) => [key, value?.[key] ?? fallback]));
}
export function validateWhip(value, endpoint) {
  const v = normalizeWhip(value);
  try {
    const url = new URL(endpoint);
    if (!["http:", "https:"].includes(url.protocol) || !url.hostname || url.username || url.password || endpoint.includes("#")) throw Error();
  } catch { return "Enter an HTTP(S) WHIP endpoint without embedded credentials or fragment"; }
  if (/[\r\n]/.test(v.whipBearerToken)) return "Bearer token must not contain line breaks";
  if (!["passthrough", "transcode"].includes(v.whipVideoMode)) return "Choose a video mode";
  if (!["h264", "vp8", "vp9"].includes(v.whipVideoCodec)) return "Choose a supported codec";
  if (!["disabled", "raw", "json", "rawAndJson"].includes(v.whipKlvMode)) return "Choose a KLV mode";
  if (v.whipRequireKlv && v.whipKlvMode === "disabled") return "Required KLV cannot be disabled";
  if (!["", "cbr", "vbr"].includes(v.whipRateControl)) return "Choose a rate control mode";
  for (const [key, max] of [["whipVideoBitrateKbps",1000000], ["whipVideoMaxBitrateKbps",1000000], ["whipVideoKeyframeInterval",10000], ["whipSignalingTimeoutMs",120000]]) {
    if (String(v[key]).trim() === "" || !Number.isInteger(Number(v[key])) || Number(v[key]) < 0 || Number(v[key]) > max) return `${key} must be an integer from 0 to ${max}`;
  }
  if (Number(v.whipVideoMaxBitrateKbps) > 0 && Number(v.whipVideoMaxBitrateKbps) < Number(v.whipVideoBitrateKbps)) return "Maximum bitrate must be at least the target bitrate";
  const pids = Array.isArray(v.whipKlvPids) ? v.whipKlvPids : String(v.whipKlvPids).trim() ? String(v.whipKlvPids).split(",").map(x => x.trim() === "" ? NaN : Number(x)) : [];
  if (pids.some(x => !Number.isInteger(x) || x < 0 || x > 8191) || new Set(pids).size !== pids.length) return "KLV PIDs must be unique integers from 0 to 8191, separated by commas";
  return "";
}
export function whipPayload(value, endpoint) {
  const v = normalizeWhip(value);
  const error = validateWhip(v, endpoint); if (error) throw Error(error);
  for (const [key, fallback] of Object.entries(whipDefaults)) if (typeof fallback === "number") v[key] = Number(v[key]);
  if (!Array.isArray(v.whipKlvPids)) v.whipKlvPids = String(v.whipKlvPids).trim() ? String(v.whipKlvPids).split(",").map(Number) : [];
  return { ...v, url: endpoint.trim() };
}
export function safeWhipEndpoint(value) {
  try { return new URL(value).origin; } catch { return "WHIP endpoint"; }
}
